var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import cn from 'classnames';
import React from 'react';
import { getComponentName } from '../utils/getComponentName';
import { camelToSnakeCase } from '../utils/camelToSnakeCase';
/** Components Registry */
var ComponentsRegistry = /** @class */ (function () {
    function ComponentsRegistry(components) {
        var names = [];
        var componentsList = components.map(function (component) {
            // check if component is registered and has a name
            if (!component.__crComponentName) {
                // eslint-disable-next-line no-console
                console.error("Component \"".concat(getComponentName(component), "\" has not been registered"));
                return null;
            }
            // check if component already exists
            if (names.includes(component.__crComponentName)) {
                // eslint-disable-next-line no-console
                console.error("Component \"".concat(component.__crComponentName, "\" already exists in the registry"));
                return null;
            }
            names.push(component.__crComponentName);
            return component;
        });
        var validComponents = componentsList.filter(function (component) { return !!component; });
        this._components = validComponents;
    }
    Object.defineProperty(ComponentsRegistry.prototype, "components", {
        /** Get all registered components */
        get: function () {
            return this._components;
        },
        enumerable: false,
        configurable: true
    });
    /** Get component by name */
    ComponentsRegistry.prototype.getComponentByName = function (name) {
        var component = this._components.find(function (item) { return item.__crComponentName === name; });
        return component;
    };
    /** Check if API has a component */
    ComponentsRegistry.prototype.apiHas = function (apiComponents, name) {
        return !!apiComponents.find(function (_a) {
            var componentName = _a.componentName;
            return componentName === name;
        });
    };
    /** Render components */
    ComponentsRegistry.prototype.render = function (apiComponentsProp, _a, render) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, cssModule = _b.cssModule, order = _b.order;
        var components = apiComponentsProp;
        // sort components
        if (order) {
            components = [];
            // sort components that are listed in the `order`
            order.forEach(function (name) {
                components.push.apply(components, apiComponentsProp.filter(function (_a) {
                    var componentName = _a.componentName;
                    return componentName === name;
                }));
            });
            // add components that are not listed in the `order`
            apiComponentsProp.forEach(function (component) {
                if (!order.includes(component.componentName)) {
                    components.push(component);
                }
            });
        }
        return (React.createElement(React.Fragment, null, components.map(function (_a) {
            var key = _a.key, componentName = _a.componentName, startProps = _a.props, childrenProp = _a.children;
            var Component = _this.getComponentByName(componentName);
            var children = childrenProp
                ? _this.render(childrenProp, { cssModule: cssModule, order: order }, render)
                : undefined;
            var props = __assign(__assign({}, startProps), { children: children, className: cn(startProps.className, cssModule && cssModule[camelToSnakeCase(componentName)]) });
            if (!Component) {
                return (React.createElement("div", { key: key },
                    "Unregistered component `",
                    componentName,
                    "`"));
            }
            if (render) {
                var result = render({
                    key: key,
                    componentName: componentName,
                    props: props,
                    Component: Component,
                });
                if (typeof result === 'undefined') {
                    throw new Error('Render method should return something!');
                }
                return result;
            }
            return (React.createElement(Component, __assign({ key: key }, props, { className: cn(props.className, cssModule && cssModule[camelToSnakeCase(componentName)]) })));
        })));
    };
    return ComponentsRegistry;
}());
export { ComponentsRegistry };
//# sourceMappingURL=ComponentsRegistry.js.map